// These are class field names, the order should not be changed to match the table column data
export const columns = Object.freeze({
  CLASS_NAME: 'className',
  CATEGORY: 'category',
  DISABLED: 'disabled',
});

export const sortOrder = Object.freeze({
  DESC: 'desc',
  ASC: 'asc',
});

export const arrowOptions = Object.freeze({
  DIRECTION: { UP: 'up', RIGHT: 'right', DOWN: 'down' },
  THEME: { BRAND: 'brand', DARK: 'dark' },
});
